import gql from "graphql-tag";

export const reorderKnowledgeBaseSectionsQuery = gql`
  mutation reorderKnowledgeBaseSections($order: [ID!]) {
    reorderKnowledgeBaseSections(order: $order) {
      id
    }
  }
`;
